
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */

import DocsBeta from 'src/components/docs/DocsBeta/index.tsx';

export const metadata = {
  feedback: true,
  toc: true,
  layout: 'guide',
  description: 'Learn how to process refunds for Variable Recurring Payments.'
};
const makeShortcode = name => function MDXDefaultShortcode(props) {
      console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope")
      return <div {...props}/>
    };
const Header = makeShortcode("Header");
const layoutProps = {
  metadata
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">

    <Header title='Refunds' subtitle='Process refunds for Variable Recurring Payments' mdxType="Header" />
    <p>{`For Variable Recurring Payments (without Virtual Accounts), refunds can be executed using your banking partner to send funds to a user's bank account.`}</p>
    <p>{`When calling `}<inlineCode parentName="p">{`/payment_initiation/consent/get`}</inlineCode>{`, you can retrieve the payer's details, such as name and account numbers, in the response. You can then use your banking partner to push the refund to the user's account.`}</p>
    <p>{`For streamlined refunds via Plaid, see `}<a parentName="p" {...{
        "href": "/docs/payment-initiation/virtual-accounts"
      }}>{`Virtual Accounts`}</a>{`.`}</p>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;

            export const tableOfContents = [
      
];
          
layoutProps.tableOfContents = tableOfContents;
MDXContent.layoutProps = layoutProps;

MDXContent.layout = function (props) { return <DocsBeta {...props} /> };
